import { SendEventProps } from '../../interfaces/biEvents';

export const mpShowMoreMetadataViewed = () =>
    ({
        eventName: 'Gig gallery - about the gig  - show more metadata viewed',
    } satisfies SendEventProps);
